module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('nav', {
    staticClass: "menu-icons"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "max-width": "340px",
      "close-on-content-click": false,
      "fixed": true,
      "z-index": "190"
    }
  }, [_c('div', {
    staticClass: "item-icon",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "far fa-bell"
  }), _vm._v(" "), (_vm.notificacoesNaoVisualizadas.length > 0) ? _c('span', {
    staticClass: "badge-notify"
  }, [_vm._v(_vm._s(_vm.notificacoesNaoVisualizadas.length))]) : _vm._e()]), _vm._v(" "), _c('v-card', {
    staticClass: "notificacoes-card"
  }, [_c('div', {
    staticClass: "notificacoes-header"
  }, [_c('h4', {
    staticClass: "notificacoes-header-title"
  }, [_vm._v("Notificações")]), _vm._v(" "), _c('a', {
    staticClass: "notificacoes-header-icon",
    attrs: {
      "title": "Marcar todas com Visualizada"
    },
    on: {
      "click": _vm.marcarTodasComoLida
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  })])]), _vm._v(" "), (_vm.notificacoesNaoAbertas.length) ? _c('v-list', {
    staticClass: "notificacoes-lista",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.notificacoesNaoAbertas), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      staticClass: "notificacoes-lista-item",
      class: {
        'notificacoes-item-visualizado': !item.visualizada_em
      },
      attrs: {
        "subheader": "",
        "three-line": "",
        "ripple": ""
      }
    }, [_c('v-list-tile-content', {
      on: {
        "click": function($event) {
          return _vm.mostrarNotificacao(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.notificacao.titulo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.notificacao.mensagem))])], 1), _vm._v(" "), _c('v-list-tile-action', {
      attrs: {
        "title": _vm._f("dateTimeEnToBr")(item.enviada_em)
      }
    }, [_c('v-list-tile-action-text', [_vm._v("\n                                    " + _vm._s(_vm._f("timeEnToBr")(item.enviada_em)) + "\n                                ")])], 1), _vm._v(" "), _c('a', {
      staticClass: "item-lista-remover",
      on: {
        "click": function($event) {
          return _vm.removerNotificacao(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])], 1), _vm._v(" "), (index + 1 < _vm.notificacoesNaoAbertas.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.notificacoesNaoAbertas.length) ? _c('div', {
    staticClass: "notificacoes-lista-vazia"
  }, [_vm._v("Não existem\n                    notificações\n                ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "notificacoes-todos",
    attrs: {
      "to": {
        name: 'notificacoes'
      }
    }
  }, [_vm._v("\n                    Todas notificações\n                ")])], 1)], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "item-icon"
  }, [_c('i', {
    staticClass: "far fa-comment"
  }), _vm._v(" "), (_vm.mensagens.length > 0) ? _c('span', {
    staticClass: "badge-notify"
  }, [_vm._v(_vm._s(_vm.mensagens.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "item-icon"
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  }), _vm._v(" "), (_vm.eventos.length > 0) ? _c('span', {
    staticClass: "badge-notify"
  }, [_vm._v(_vm._s(_vm.eventos.length))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.mostrarModalNotificacao),
      callback: function($$v) {
        _vm.mostrarModalNotificacao = $$v
      },
      expression: "mostrarModalNotificacao"
    }
  }, [_c('v-card', {
    staticClass: "modal-notificacao"
  }, [_c('h3', [_vm._v(_vm._s(_vm.notificacao.notificacao.titulo))]), _vm._v(" "), _c('div', {
    staticClass: "modal-notificacao-texto"
  }, [_vm._v(_vm._s(_vm.notificacao.notificacao.mensagem))]), _vm._v(" "), _c('div', {
    staticClass: "modal-notificacao-data"
  }, [_vm._v("\n                Enviada em: "), _c('span', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.notificacao.enviada_em)))])]), _vm._v(" "), (_vm.notificacao.visualizada_em) ? _c('div', {
    staticClass: "modal-notificacao-data"
  }, [_vm._v("\n                Visualizada em: "), _c('span', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.notificacao.visualizada_em)))])]) : _vm._e(), _vm._v(" "), (_vm.notificacao.aberta_em) ? _c('div', {
    staticClass: "modal-notificacao-data"
  }, [_vm._v("\n                Aberta em: "), _c('span', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.notificacao.aberta_em)))])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2970473e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/header/Notificacoes.vue
// module id = 531
// module chunks = 2